import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SpecraTabBar } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { useSearchParams } from 'react-router-dom';
import { DocumentsTab } from './DocumentsTab';
import { LineageTab } from './LineageTab';
import { ModificationsTab } from './ModificationsTab';
const SUB_TABS = [
    'documents',
    'modifications',
    'lineage'
];
const PANELS = {
    documents: DocumentsTab,
    modifications: ModificationsTab,
    lineage: LineageTab
};
export function DocsTab({ programId }) {
    // ?tab= deep-links a sub-tab (the retired /v2?screen=modifications redirect,
    // the program-home work panel and chat links land on it directly). The URL
    // is the state, so a link followed while Docs is already open still lands.
    const [searchParams, setSearchParams] = useSearchParams();
    const requested = searchParams.get('tab');
    const active = requested && SUB_TABS.includes(requested) ? requested : 'documents';
    const setActive = (next)=>setSearchParams((prev)=>{
            const params = new URLSearchParams(prev);
            params.set('tab', next);
            // set / item / doc belong to the sub-tab they were set on.
            for (const key of [
                'set',
                'item',
                'doc'
            ])params.delete(key);
            return params;
        }, {
            replace: true
        });
    // Only the active panel mounts — the same lifecycle Radix TabsContent had.
    const ActivePanel = PANELS[active];
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(SpecraTabBar, {
                label: "Documents sections",
                value: active,
                onValueChange: setActive,
                options: [
                    {
                        value: 'documents',
                        label: 'Documents',
                        testId: Testids.deliveryDocs.subTabDocuments
                    },
                    {
                        value: 'modifications',
                        label: 'Modifications',
                        testId: Testids.deliveryDocs.subTabModifications
                    },
                    {
                        value: 'lineage',
                        label: 'Lineage',
                        testId: Testids.deliveryDocs.subTabLineage
                    }
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "mt-6",
                children: /*#__PURE__*/ _jsx(ActivePanel, {
                    programId: programId
                }, active === 'modifications' ? `modifications:${searchParams.get('set') ?? ''}` : active)
            })
        ]
    });
}
